import dayjs from "dayjs";
import { modeList } from "./enumList";

export const dateFormatDisplay = (date) => {
  return date && dayjs(date).format("DD-MM-YYYY");
};

export const formatInterviewDatetime = (value) => {
  // Split the input into date and time parts
  const [datePart, timePart] = value.split(" | ");

  // Parse the date part
  const [day, month, year] = datePart.split(" ");
  const months = {
    Jan: "01",
    Feb: "02",
    Mar: "03",
    Apr: "04",
    May: "05",
    Jun: "06",
    Jul: "07",
    Aug: "08",
    Sep: "09",
    Oct: "10",
    Nov: "11",
    Dec: "12",
  };

  // Parse the time part
  const [time, meridian] = timePart.split(" ");
  let [hours, minutes] = time.split(":").map(Number);

  // Convert 12-hour time to 24-hour time
  if (meridian === "PM" && hours !== 12) {
    hours += 12;
  } else if (meridian === "AM" && hours === 12) {
    hours = 0;
  }

  // Format the date and time into the desired format
  const formattedDate = `${year}-${months[month]}-${day.padStart(2, "0")}`;
  const formattedTime = `${String(hours).padStart(2, "0")}:${String(
    minutes
  ).padStart(2, "0")}`;

  return `${formattedDate} ${formattedTime}`;
};

export const formatUIDateTime = (isoString) => {
  const date = new Date(isoString);

  // Convert to IST (UTC+5:30)
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  };

  // Get formatted parts
  const formatter = new Intl.DateTimeFormat("en-US", options);
  const parts = formatter.formatToParts(date);

  // Extract parts
  let day, month, year, hour, minute, period;
  for (const part of parts) {
    if (part.type === "day") day = part.value;
    if (part.type === "month") month = part.value;
    if (part.type === "year") year = part.value;
    if (part.type === "hour") hour = part.value;
    if (part.type === "minute") minute = part.value;
    if (part.type === "dayPeriod") period = part.value;
  }

  return `${day} ${month} ${year} | ${hour}:${minute} ${period}`;
};

export const formatUTCDateTime = (isoString) => {
  const date = new Date(isoString);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = monthNames[date.getUTCMonth()];
  const year = date.getUTCFullYear();

  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // 0 should be 12
  const formattedHour = String(hours).padStart(2, "0");

  return `${day} ${month} ${year} | ${formattedHour}:${minutes} ${ampm}`;
};

export const emailRequestBody = (
  singleCandidate,
  singleRequisition,
  formData,
  index
) => {
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const startDateTime = new Date(
    formatInterviewDatetime(formData.itl_interviewdatetime)
  );
  const endDateTime = new Date(startDateTime);
  endDateTime.setMinutes(
    startDateTime.getMinutes() + (formData.itl_duration - "")
  ); // ✅ Accurate 30-minute duration

  const isOnline = formData.itl_mode === 1;

  const requestBody = {
    subject: `Interview Schedule | ${singleCandidate.lastname} | ${singleRequisition.itl_name}`,
    start: {
      dateTime: startDateTime.toISOString(),
      timeZone: "UTC",
    },
    end: {
      dateTime: endDateTime.toISOString(),
      timeZone: "UTC",
    },
    attendees: [
      {
        emailAddress: {
          address: singleCandidate.itl_emailid,
        },
        type: "required",
      },
      {
        emailAddress: {
          address: formData.interviewer_email,
        },
        type: "required",
      },
      {
        emailAddress: {
          address: "shyamali.m@intelegain.com",
        },
        type: "required",
      },
      {
        emailAddress: {
          address: "shalini@intelegain.com",
        },
        type: "required",
      },
      {
        emailAddress: {
          address: "mansi.y@intelegain.com",
        },
        type: "required",
      },
      {
        emailAddress: {
          address: "karishma.s@intelegain.com",
        },
        type: "required",
      },
    ],
    location: {
      displayName: isOnline ? "Microsoft Teams Meeting" : "Intelegain Office",
    },
    body: {
      contentType: "HTML",
      content: `
        <p>Dear ${singleCandidate.lastname.split(" ")[0]},</p>
        <p>As per discussion, this mail is confirmation of your ${
          modeList.text[formData.itl_mode]
        } Schedule with Intelegain Technologies Pvt Ltd.</p>
        <p>Kindly confirm your availability for the above-mentioned schedule by replying to this mail.</p>
        <p>Kindly go through the Company details & JD.</p>
        <p><strong>Company Name:</strong> Intelegain Technologies Pvt Ltd - "Empowering Business Transformation".</p>
        <p><strong>Web:</strong> <a href="https://www.intelegain.com" target="_blank">www.intelegain.com</a></p>
        <p><strong>Company Profile:</strong></p>
        <p>Intelegain is a 25-year-old global technology and innovation company headquartered in Navi Mumbai with offices in Dallas, Singapore, and Sydney. Our services focus on cloud enablement, technology consulting, and software development. Intelegain is a Microsoft Gold Partner, Amazon Consulting Partner & Intuit Development Partner and a member of IAMCP (International Association of Microsoft Channel Partners).</p>
        <p><strong>Experience Required:</strong>  
          ${singleRequisition.itl_relevantexperienceyears} year${
        singleRequisition.itl_relevantexperienceyears > 1 ? "s" : ""
      } 
          ${
            singleRequisition?.itl_relevantexperiencemonths &&
            singleRequisition.itl_relevantexperiencemonths !== 0
              ? `${singleRequisition.itl_relevantexperiencemonths} month${
                  singleRequisition.itl_relevantexperiencemonths > 1 ? "s" : ""
                }`
              : ""
          } 
          as ${singleRequisition.itl_name}.
        </p>
        <p><strong>Salary:</strong> Open to Discuss.</p>
        <p><strong>Job Description:</strong></p>
        <p>${singleRequisition.itl_newjobdescription.replace(/\n/g, "<br>")}</p>
        <p><strong>Note:</strong> Salary & Designation will depend on the further interview conversations.</p>      
        <p>Thanks & Regards, <br/>
          <strong>${user?.displayName}</strong><br/>
          ${user?.jobTitle} | Intelegain Technologies Pvt. Ltd.<br/>
          Email: <a href="mailto:${user?.mail}">${user?.mail}</a><br/>
          Location: Navi Mumbai, Turbhe.<br/>
          Company Website: <a href="https://www.intelegain.com" target="_blank">www.intelegain.com</a>
        </p>
        
        ${
          !isOnline
            ? `
          <p>
            <strong>Venue Details:</strong> 203, Akshar Bluechip IT Park,
            Turbhe MIDC, Turbhe, New Mumbai, Maharashtra 400705.
          </p>
        `
            : ""
        }        
      `,
    },
  };

  // Add Teams fields only if online
  if (isOnline) {
    requestBody.isOnlineMeeting = true;
    requestBody.onlineMeetingProvider = "teamsForBusiness";
  }

  return requestBody;
};

export const filterAndTransform = (data, roleType) => {
  return data
    .filter((item) => item.itl_roletype === roleType) // Filter by `itl_roletype`
    .map((item) => ({
      value: item.accountid, // Transform to required format
      label: item.name,
    }));
};

export function dataURLToFile(dataURL, fileName) {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
}